import {observer} from "mobx-react";
import {Fragment, useRef, useState} from "react";
import DateTimeV2, {DATETIME_VIEW} from "../../../../../components/datetime-v2/datetime-v2";
import {FontBody1} from "../../../../../components/fonts/font-body1/font-body1";
import {FontBody2} from "../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import Hr from "../../../../../components/hr/hr";
import iconPlus from "../../../../../components/icons/icon-plus/icon-plus";
import {ButtonIcon} from "../../../../../components/inputs/button-icon/button-icon";
import Card from "../../../../../components/layouts/card/card";
import ListLayout from "../../../../../components/layouts/list-layout/list-layout";
import RmaPageStore from "../../stores/rma-page-store";
import TimelineManagerStore from "../../stores/timeline-manager-store";
import NewTimelineItem from "./new-timeline-item";
import TimelineItem from "./timeline-item";
import './timeline-card.scss';
import { CARD_SPACING_VARIANT } from "../../../../../components/layouts/card/card.types";
import rmsMixpanelStore from "../../../../../stores/rms-mixpanel-store";
import { useDateTimeFormattingParams } from "../../../../../hooks/use-datetime-formatting-params";

interface ITimelineCardProps {
    timelineManagerStore: TimelineManagerStore;
    rmaMainStore:RmaPageStore;
}
const TimelineCard : React.FC<ITimelineCardProps> = observer(({timelineManagerStore, rmaMainStore})=> {
    const [isExpanded, setExpanded] = useState(true);
    const dateTimeParams = useDateTimeFormattingParams();
    const timelineItems = timelineManagerStore.getGroups();
    const ref = useRef<HTMLDivElement>(null)
    return (
        <div className={'timeline-card'}>
            <Card
                isExpandable={true}
                isExpanded={isExpanded}
                expandCallback={setExpanded}
                spacingVariant={CARD_SPACING_VARIANT.SMAll}
                toolbar={{
                    title: <FontBody1 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>Timeline</FontBody1>,
                    content: <ButtonIcon
                                Component={iconPlus}
                                disabled={rmaMainStore.isSavingNewNote}
                                onClick={()=>{
                                    rmsMixpanelStore.trackEvent('d&_add_note_timeline');
                                    setExpanded(true);
                                    rmaMainStore.showNewTimelineNote();
                                    if(ref.current){
                                        ref.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
                                    }
                                }}
                             />
                }}
            >
                <ListLayout>
                    <div className={'timeline-message-container place-right'} ref={ref}>
                        {rmaMainStore.displayNewTimelineNote && <NewTimelineItem rmaMainStore={rmaMainStore}/>}
                    </div>
                    {timelineItems.map((dateGroup, index) =>
                        <Fragment key={dateGroup.date}>
                                <div className={'timeline-date-separator'}>
                                    <FontBody2 variant={FONT_VARIANT.BOLD}>
                                        <DateTimeV2 {...dateTimeParams} utcDateString={dateGroup.dateForDivider} dateTimeView={DATETIME_VIEW.DATE_ONLY}/>
                                    </FontBody2>
                                    <Hr/>
                                </div>
                                <ListLayout>
                                    {
                                        dateGroup.items.map((listItem, index) =>
                                            <TimelineItem store={listItem} rmaId={rmaMainStore.rmaId} key={index}/>
                                        )
                                    }
                                </ListLayout>
                            </Fragment>
                    )
                    }
                </ListLayout>
            </Card>
        </div>
    )
});

export default TimelineCard;